import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { UserIdentity } from '../../helpers/common/user.identity';
import { AuthenticationService } from 'app/_services';

@Component({
    moduleId: module.id,
    selector: 'app-logout',
    templateUrl: `../views/logout.component.html`
})

export class LogoutComponent implements OnInit {

    constructor(private _router: Router, private authenticationService: AuthenticationService  ) { }

    ngOnInit(): void {
        // reset login status
        this.authenticationService.storeLogout().subscribe(res => {});
        UserIdentity.signOut();
        this._router.navigate(['/login']);
    }
}
